import { render } from "./messageDialog.vue?vue&type=template&id=97d9e8ee&scoped=true"
import script from "./messageDialog.vue?vue&type=script&lang=js"
export * from "./messageDialog.vue?vue&type=script&lang=js"

import "./messageDialog.vue?vue&type=style&index=0&id=97d9e8ee&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97d9e8ee"]])

export default __exports__